import ToolkitMixin from '@/app/mixins/toolkit/item';

export default {
  name: 'inv-strat-objective',
  mixins: [ToolkitMixin],
  computed: {
    years: {
      get() {
        return this.getItem.objective.years;
      },
      set(value) {
        this.setItem({
          objective: {
            percent: this.percent,
            years: value,
          },
        });
      },
    },
    percent: {
      get() {
        return this.getItem.objective.percent;
      },
      set(value) {
        this.setItem({
          objective: {
            percent: value,
            years: this.years,
          },
        });
      },
    },
  },
};
